import React, { useState } from 'react';
import { Button, Dropdown, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { downloadBlobResponse } from '../utils/downloadBlob';

const ITEMS = [
  { key: 'xlsx', label: 'Excel (.xlsx)' },
  { key: 'csv', label: 'CSV (.csv)' },
];

export default function ExportButton({ onExport, filenameBase = 'export', disabled = false }) {
  const [loading, setLoading] = useState(false);

  const handleExport = async ({ key }) => {
    setLoading(true);
    try {
      const response = await onExport(key);
      downloadBlobResponse(response, `${filenameBase}.${key}`);
    } catch (error) {
      message.error(error?.response?.data?.detail || 'Не удалось скачать экспорт');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dropdown
      menu={{ items: ITEMS, onClick: handleExport }}
      trigger={['click']}
      disabled={disabled || loading}
    >
      <Button icon={<DownloadOutlined />} loading={loading}>
        Экспорт
      </Button>
    </Dropdown>
  );
}
